import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Button, Grid, Card, CardContent, Typography, Paper, Chip, Pagination, TextField, InputAdornment, IconButton, CircularProgress } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef, useCallback } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { io } from "socket.io-client";
import SearchIcon from '@mui/icons-material/Search';
import TaiXiuHeaderNav from "../../components/TaiXiuHeaderNav";

import xx1 from "../../static/txmd5/xx1_1.png";
import xx2 from "../../static/txmd5/xx2_1.png";
import xx3 from "../../static/txmd5/xx3_1.png";
import xx4 from "../../static/txmd5/xx4_1.png";
import xx5 from "../../static/txmd5/xx5_1.png";
import xx6 from "../../static/txmd5/xx6_1.png";

const diceImages = { 1: xx1, 2: xx2, 3: xx3, 4: xx4, 5: xx5, 6: xx6 };
const SERVER_URL = process.env.REACT_APP_API_URL_MAIN;
const SOCKET_URL = process.env.REACT_APP_API_URL_SOCKET_TXMD560S;

function SetTXMD5() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));

    const [rawTime, setRawTime] = useState(0);
    const [displayTime, setDisplayTime] = useState(0);
    const [gameState, setGameState] = useState("");
    const [phien, setPhien] = useState("...");
    const [result, setResult] = useState("...");

    const [totalMoneyTai, setTotalMoneyTai] = useState(0);
    const [totalMoneyXiu, setTotalMoneyXiu] = useState(0);
    const [totalUserTai, setTotalUserTai] = useState(0);
    const [totalUserXiu, setTotalUserXiu] = useState(0);
    const [usersTai, setUsersTai] = useState([]);
    const [usersXiu, setUsersXiu] = useState([]);

    const [adminSettingMsg, setAdminSettingMsg] = useState(null);
    const [selectedDice, setSelectedDice] = useState([]); 
    
    const [listSessionHistory, setListSessionHistory] = useState([]); 
    const [listPlayerHistory, setListPlayerHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);
      
    const [chimMoiList, setChimMoiList] = useState([]);
    const abortControllerRef = useRef(null);
    const socketRef = useRef();

    function formatDateTimeFull(dateStr) {
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    useEffect(() => {
        socketRef.current = io(SOCKET_URL);

        socketRef.current.on("tx_time", (data) => {
            const serverTime = data.time;
            setRawTime(serverTime);

            if (serverTime > 15) {
                setDisplayTime(serverTime - 15);
                setGameState("ĐANG ĐẶT CƯỢC");
            } else {
                setDisplayTime(serverTime);
                setGameState("TRẢ THƯỞNG / MỞ BÁT");
            }

            if (data.data) setPhien(data.data.id_bet);

            if (data.lists) {
                const listTai = data.lists.tai || [];
                const listXiu = data.lists.xiu || [];
                setUsersTai(listTai);
                setUsersXiu(listXiu);
                setTotalMoneyTai(listTai.reduce((sum, item) => sum + Number(item.money), 0));
                setTotalMoneyXiu(listXiu.reduce((sum, item) => sum + Number(item.money), 0));
                setTotalUserTai(listTai.length);
                setTotalUserXiu(listXiu.length);
            }

            setAdminSettingMsg(data.admin_setting || null);
        });

        socketRef.current.on("tx_result", (data) => {
            setResult(data.result);
            fetchHistorySession();
            setAdminSettingMsg(null);
            setSelectedDice([]); 
        });

        socketRef.current.on("tx_new_session", (data) => {
            setPhien(data.id_bet);
            setResult("...");
            setTotalMoneyTai(0); setTotalMoneyXiu(0);
            setTotalUserTai(0); setTotalUserXiu(0);
            setUsersTai([]); setUsersXiu([]);
            setAdminSettingMsg(null);
            setSelectedDice([]); 
        });

        fetchHistorySession();
        fetchPlayerHistory(1, "", false); 
        fetchChimMoiList(); 

        return () => {
            if (socketRef.current) socketRef.current.disconnect();
        };
    }, []);

  const fetchPlayerHistory = useCallback((pageNum, keyword, isSilent = false) => {
    if (!isSilent) setIsLoadingHistory(true); 

    const query = keyword ? `&username=${keyword}` : "";
    axios.get(`${SERVER_URL}/taixiumd560s/history-all-players?page=${pageNum}&limit=10${query}`)
        .then((res) => {
            if (res.data.success) {
                setListPlayerHistory(res.data.data);
                setTotalPages(res.data.totalPages || 1);
            }
        })
        .catch((err) => console.log(err))
        .finally(() => {
            if (!isSilent) setIsLoadingHistory(false);
        });
}, []);

    const fetchChimMoiList = () => {
        const codeChimMoi = `md560s`; 
        axios.get(`${process.env.REACT_APP_API_URL}/auth/chimmoi?code=${codeChimMoi}`)
            .then(res => {
                if (res.data && res.data.data) {
                    setChimMoiList(res.data.data);
                }
            })
            .catch(err => {
                console.log("Không lấy được danh sách chim mồi", err);
                setChimMoiList([]);
            });
    };

    useEffect(() => {
        const silentUpdateTimer = setInterval(() => {
            fetchPlayerHistory(page, searchKeyword, true); 
        }, 3000);

        return () => clearInterval(silentUpdateTimer);
    }, [page, searchKeyword, fetchPlayerHistory]);

    const fetchHistorySession = () => {
        axios.get(`${SERVER_URL}/taixiumd560s/getallbet?limit=20`).then((res) => {
            if (res.data.success) {
                const filteredData = res.data.data.filter(item => item.result);
                setListSessionHistory(filteredData.slice(0, 20)); 
            }
        }).catch(() => {});
    };

    const handleSearch = () => { setPage(1); fetchPlayerHistory(1, searchKeyword, false); };

    const handleSelectDice = (val) => {
        if (selectedDice.length >= 3) return swal("Thông báo", "Tối đa 3 viên!", "warning");
        setSelectedDice([...selectedDice, val]);
    };
    const handleResetDice = () => {
        setSelectedDice([]);
        if(rawTime > 16) axios.get(`${SERVER_URL}/taixiumd560s/api/set-result/clear`);
    };
    const submitDiceResult = async () => {
        if (rawTime <= 16) return swal("Hết giờ!", "Đã quá thời gian chỉnh cầu", "warning");
        if (selectedDice.length !== 3) return swal("Chưa đủ", "Vui lòng chọn 3 viên", "warning");
        try {
            const res = await axios.get(`${SERVER_URL}/taixiumd560s/api/set-dice/${selectedDice[0]}/${selectedDice[1]}/${selectedDice[2]}`);
            if (res.data.success) swal("Thành công", res.data.message, "success");
        } catch (error) {}
    };
    const setTaiXiuRandom = async (side) => {
        if (rawTime <= 16 && side !== "clear") return swal("Hết giờ!", "Đã quá thời gian", "warning");
        if(side === "clear") {
            try {
                await axios.get(`${SERVER_URL}/taixiumd560s/api/set-result/clear`);
                setSelectedDice([]);
                swal("Đã Hủy", "Chạy ngẫu nhiên", "success");
            } catch (e) {}
            return;
        }
        try {
            const res = await axios.get(`${SERVER_URL}/taixiumd560s/api/set-result/${side}`);
            if (res.data.success) {
                if(res.data.dice) setSelectedDice(res.data.dice);
                swal("Thành công", res.data.message, "success");
            }
        } catch (error) {}
    };
    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const UserListTable = ({ users, title, color }) => (
        <Paper sx={{ maxHeight: 300, overflow: 'auto', bgcolor: '#f5f5f5', border: `1px solid ${color}` }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold', color: color, bgcolor: '#eee' }}>User ({users.length})</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: color, textAlign: 'right', bgcolor: '#eee' }}>Tiền</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users && users.length > 0 ? (
                        users.map((u, i) => (
                            <TableRow key={i}>
                                <TableCell>{u.user?.username || "Ẩn danh"}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#333' }}>{formatMoney(u.money)}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow><TableCell colSpan={2} align="center" sx={{ color: '#aaa', py: 3 }}>Trống</TableCell></TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                {profile?.permission?.set == 1 ? (
                    <Box component="main" sx={{ flexGrow: 1, py: 2, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
                        <Container maxWidth={false}>
                            <TaiXiuHeaderNav currentMode="txmd5" currentSanh={1} />
                            <div className="container_set" style={{ fontSize: '28px', fontWeight: '900', marginBottom: '20px', textAlign: 'center', color: '#10B981', textTransform: 'uppercase' }}>
                                QUẢN TRỊ TÀI XỈU MD5
                            </div>

                            <Grid container spacing={2} sx={{mb: 2}}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ border: '1px solid #ddd', height: '100%', boxShadow: 2 }}>
                                        <CardContent>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item xs={6} style={{ textAlign: 'center' }}>
                                                    <Typography variant="h6" color="textSecondary">PHIÊN HIỆN TẠI</Typography>
                                                    <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold' }}>#{phien}</Typography>
                                                    <div style={{ fontSize: '60px', fontWeight: 'bold', color: rawTime <= 15 ? '#D32F2F' : '#10B981', fontFamily: 'monospace', lineHeight: 1 }}>{displayTime}</div>
                                                    <Typography variant="body2">{gameState}</Typography>
                                                    {adminSettingMsg && <Chip label={adminSettingMsg} color="warning" sx={{mt:1}} />}
                                                </Grid>
                                                <Grid item xs={6} style={{ textAlign: 'center' }}>
                                                    <Typography variant="h6" color="textSecondary">KẾT QUẢ</Typography>
                                                    <Typography variant="h3" color="secondary" sx={{ fontWeight: 'bold' }}>{result}</Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                
                                {/* --- 2. CHỌN KẾT QUẢ --- */}
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ border: '2px solid #10B981', height: '100%', boxShadow: 2 }}>
                                        <CardContent>
                                            <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', color: '#10B981', mb: 1 }}>CHỌN KẾT QUẢ</Typography>
                                            <Grid container spacing={1} justifyContent="center" alignItems="center">
                                                {[1, 2, 3, 4, 5, 6].map((val) => {
                                                    const isSelected = selectedDice.includes(val);
                                                    const count = selectedDice.filter(x => x === val).length;
                                                    return (
                                                        <Grid item key={val} style={{position: 'relative'}}>
                                                            <img 
                                                                src={diceImages[val]} alt={`Dice ${val}`} onClick={() => handleSelectDice(val)}
                                                                style={{ 
                                                                    width: '50px', cursor: 'pointer', borderRadius: '8px', 
                                                                    boxShadow: isSelected ? '0 0 10px #10B981' : '0 2px 4px rgba(0,0,0,0.2)',
                                                                    transform: isSelected ? 'scale(1.15)' : 'scale(1)',
                                                                    border: isSelected ? '2px solid #10B981' : 'none', transition: 'all 0.2s ease'
                                                                }}
                                                            />
                                                            {count > 0 && <span style={{position: 'absolute', top: -5, right: -5, background: 'red', color: 'white', borderRadius: '50%', width: 20, height: 20, textAlign: 'center', fontSize: 12, lineHeight: '20px'}}>{count}</span>}
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                            {selectedDice.length > 0 ? (
                                                <Typography align="center" sx={{mt:1, fontWeight:'bold', color: '#333'}}>
                                                    Dự kiến: {selectedDice.join(" - ")} (Tổng: {selectedDice.reduce((a,b)=>a+b,0)} - {selectedDice.reduce((a,b)=>a+b,0) > 10 ? "TÀI" : "XỈU"})
                                                </Typography>
                                            ) : <Typography align="center" sx={{mt:1, fontStyle:'italic', color:'#aaa'}}>Chưa chọn kết quả</Typography>}

                                            <Box sx={{ mt: 1, textAlign: 'center', display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <Button variant="outlined" size="small" onClick={handleResetDice}>XÓA</Button>
                                                <Button variant="contained" color="success" size="small" onClick={submitDiceResult} disabled={rawTime <= 16}>XÁC NHẬN</Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} sx={{mb: 4}}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ bgcolor: '#fff', borderTop: '5px solid #000', boxShadow: 2 }}>
                                        <CardContent>
                                            <Box sx={{ textAlign: 'center', mb: 1, bgcolor: '#000', p: 1, borderRadius: 1, color: '#fff' }}>
                                                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>TÀI - <span style={{color: '#10B981'}}>{formatMoney(totalMoneyTai)}</span></Typography>
                                            </Box>
                                            <UserListTable users={usersTai} title="Tài" color="#000" />
                                            <Button variant="contained" style={{backgroundColor: '#333'}} fullWidth onClick={() => setTaiXiuRandom("3")} disabled={rawTime <= 16} sx={{ mt: 1 }}>SET VỀ TÀI (Ngẫu nhiên)</Button>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ bgcolor: '#fff', borderTop: '5px solid #D32F2F', boxShadow: 2 }}>
                                        <CardContent>
                                            <Box sx={{ textAlign: 'center', mb: 1, bgcolor: '#D32F2F', p: 1, borderRadius: 1, color: '#fff' }}>
                                                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>XỈU - <span style={{color: '#FFEB3B'}}>{formatMoney(totalMoneyXiu)}</span></Typography>
                                            </Box>
                                            <UserListTable users={usersXiu} title="Xỉu" color="#D32F2F" />
                                            <Button variant="contained" color="error" fullWidth onClick={() => setTaiXiuRandom("4")} disabled={rawTime <= 16} sx={{ mt: 1 }}>SET VỀ XỈU (Ngẫu nhiên)</Button>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            
                            <Box sx={{ mt: 1, mb: 3, textAlign: 'center' }}>
                                <Button variant="outlined" color="error" onClick={() => setTaiXiuRandom("clear")} disabled={rawTime <= 16}>HỦY CAN THIỆP</Button>
                            </Box>

                            <Paper elevation={3} sx={{ mt: 4, mb: 4, borderRadius: 2, overflow: 'hidden' }}>
                               
                                <Table>
                                    <TableHead>
                                        <TableRow sx={{ bgcolor: '#fff3e0' }}>
                                            <TableCell style={{ fontWeight: 'bold', width: '10%' }}>STT</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', width: '20%' }}>ID User</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', width: '40%' }}>Tài Khoản</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', width: '30%' }}>Mã Lệnh Đang Ép</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {chimMoiList && chimMoiList.length > 0 ? (
                                            chimMoiList.map((item, idx) => (
                                                <TableRow key={idx} hover>
                                                    <TableCell style={{ fontWeight: 'bold' }}>{idx + 1}</TableCell>
                                                    <TableCell>{item.iduser}</TableCell>
                                                    <TableCell style={{ color: '#1976d2', fontWeight: 'bold' }}>{item.username}</TableCell>
                                                    <TableCell style={{ color: 'red', fontWeight: 'bold' }}>{item.win}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                <TableCell colSpan={4}>Không có Chim Mồi nào được cài ở game này.</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Paper>

                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid item xs={12}>
                                    <Card sx={{ height: '100%', border: '1px solid #10B981', boxShadow: 3 }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#10B981', fontSize: '16px' }}>LỊCH SỬ CƯỢC (NGƯỜI CHƠI)</Typography>
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <TextField 
                                                        size="small" placeholder="Tìm username..." 
                                                        value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                                        InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={handleSearch}><SearchIcon /></IconButton></InputAdornment>) }}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box sx={{ overflowX: 'auto', minHeight: 300 }}>
                                                {isLoadingHistory ? <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box> : (
                                                    <Table size="small">
                                                        <TableHead><TableRow sx={{ bgcolor: '#E0F2F1' }}>
                                                            <TableCell>Thời gian</TableCell>
                                                            <TableCell>Người chơi</TableCell>
                                                            <TableCell>Phiên</TableCell>
                                                            <TableCell align="center">Cửa</TableCell>
                                                            <TableCell align="right">Tiền</TableCell>
                                                            <TableCell align="right">Thắng</TableCell>
                                                        </TableRow></TableHead>
                                                        <TableBody>
                                                            {listPlayerHistory && listPlayerHistory.length > 0 ? listPlayerHistory.map((item) => (
                                                                <TableRow key={item._id} hover>
                                                                    <TableCell style={{fontSize:'12px'}}>{formatDateTimeFull(item.createdAt)}</TableCell>
                                                                    <TableCell sx={{fontWeight:'bold', color: '#1976D2'}}>{item.user ? item.user.username : '...'}</TableCell>
                                                                    <TableCell>#{item.id_bet}</TableCell>
                                                                    <TableCell align="center"><Chip label={item.state === "3" ? "Tài" : "Xỉu"} color={item.state === "3" ? "default" : "error"} size="small" sx={{fontWeight: 'bold'}} /></TableCell>
                                                                    <TableCell align="right">{formatMoney(item.money)}</TableCell>
                                                                    <TableCell align="right" sx={{color: 'green', fontWeight:'bold'}}>{item.moneythang > 0 ? `+${formatMoney(item.moneythang)}` : ""}</TableCell>
                                                                </TableRow>
                                                            )) : <TableRow><TableCell colSpan={6} style={{ textAlign: "center", padding: 20 }}>Không tìm thấy dữ liệu</TableCell></TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                )}
                                            </Box>
                                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                                <Pagination 
    count={totalPages} 
    page={page} 
    onChange={(e, val) => {
        setPage(val); 
        fetchPlayerHistory(val, searchKeyword, false);
    }} 
    color="primary" 
    showFirstButton 
    showLastButton 
    size="small" 
/>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid item xs={12}>
                                    <Card sx={{ height: '100%', border: '1px solid #ddd' }}>
                                        <CardContent>
                                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', fontSize: '16px' }}>LỊCH SỬ PHIÊN (20 Phiên gần nhất)</Typography>
                                            <Box sx={{ overflowX: 'auto' }}>
                                                <Table size="small" padding="none"> 
                                                    <TableHead><TableRow sx={{ bgcolor: '#eee' }}>
                                                        <TableCell align="center" sx={{p:1}}>Phiên</TableCell>
                                                        <TableCell align="center" sx={{p:1}}>Kết quả</TableCell>
                                                        <TableCell align="center" sx={{p:1}}>Tổng</TableCell>
                                                        <TableCell align="center" sx={{p:1}}>Thời gian</TableCell>
                                                    </TableRow></TableHead>
                                                    <TableBody>
                                                        {listSessionHistory.map((item) => {
                                                            const dice = item.result.split(" ").map(Number);
                                                            const sum = dice.reduce((a, b) => a + b, 0);
                                                            return (
                                                                <TableRow key={item._id} hover>
                                                                    <TableCell align="center" sx={{fontWeight:'bold', fontSize:'13px', p:1}}>#{item.id_bet}</TableCell>
                                                                    <TableCell align="center" sx={{p:1}}><div style={{display:'flex', gap:2, justifyContent:'center'}}>{dice.map((d, k) => <img key={k} src={diceImages[d]} width="20px" alt="" />)}</div></TableCell>
                                                                    <TableCell align="center" sx={{fontWeight:'bold', fontSize:'13px', color: sum > 10 ? 'black' : 'red', p:1}}>{sum} ({sum > 10 ? 'T' : 'X'})</TableCell>
                                                                    <TableCell align="center" sx={{fontSize:'12px', p:1}}>{formatDateTimeFull(item.createdAt)}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                        </Container>
                    </Box>
                ) : (
                    <div style={{ padding: 20, textAlign: 'center' }}>{t('not_permission')}</div>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetTXMD5;
